import { render, staticRenderFns } from "./SupervisorModule.vue?vue&type=template&id=633a6883"
import script from "./SupervisorModule.vue?vue&type=script&lang=js"
export * from "./SupervisorModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports